const DEFAULT_LOCALE = 'en';
const LOCALE_SEPARATOR = ';';

export function getLocale() {
  const searchParams = new URLSearchParams(window.location.search);
  const localeParam = searchParams.get('locale') || '';
  if (!localeParam) {
    return { pspLocale: DEFAULT_LOCALE, customLocale: DEFAULT_LOCALE };
  }

  const separatorIndex = localeParam.lastIndexOf(LOCALE_SEPARATOR);
  if (separatorIndex > -1) {
    const customLocale = localeParam.slice(0, separatorIndex);
    const pspLocale = localeParam.slice(separatorIndex + 1);
    return {
      pspLocale,
      customLocale,
    };
  }

  const locale = localeParam || DEFAULT_LOCALE;
  return {
    pspLocale: locale,
    customLocale: locale,
  };
}
